/**
 * Created by fers on 25.07.16.
 */

import Relay from 'react-relay';
import PropTypes from 'prop-types';

interface PlayPauseFlowMutationProps {
    flow_id: string;
    organisation_id: string;
    pause: boolean;
}

export default class PlayPauseFlowMutation extends Relay.Mutation<PlayPauseFlowMutationProps> {
    static propTypes = {
        flow_id: PropTypes.string.isRequired,
        organisation_id: PropTypes.string.isRequired,
        pause: PropTypes.bool.isRequired,
    };

    getMutation() {
        return Relay.QL`mutation {playPauseFlow}`;
    }

    getVariables() {
        return {
            flow_id: this.props.flow_id,
            organisation_id: this.props.organisation_id,
            pause: this.props.pause,
        };
    }

    getFatQuery() {
        return Relay.QL`
          fragment on PlayPauseFlowPayload {
              clientMutationId,
              updatedNode {
                  id,
                  realId,
                  enabled,
                  status,
                  activated,
                  paused,
              }
          }
        `;
    }

    getConfigs() {
        return [{
            type: 'REQUIRED_CHILDREN',
            children: [
                this.getFatQuery()
            ],
        }];
    }
}
